import { PERPAY_PLUS_STEPS } from '@perpay-web/fintech/constants/steps/perpayPlusSteps';
import { withReduxStepsReducer } from '@perpay-web/hooks/useReduxSteps';

export default withReduxStepsReducer(PERPAY_PLUS_STEPS);
